// extracted by mini-css-extract-plugin
module.exports = {"inputShift":"_1ChK1","active":"_1dFMP","phoneNumberPrefix":"iUuI0","withPrefix":"_3uLbc","error":"_274Cx"};